import * as React from "react";
import { forwardRef } from "react";
const SvgRow = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} ref={ref} aria-labelledby={titleId} aria-describedby={descId} {...props}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path fill="#232F3E" d="M0 20V0h20v20zm1.905-6v4h16.19v-4zm0-2h16.19V8H1.905zm0-6h16.19V2H1.905z" /></svg>;
const ForwardRef = forwardRef(SvgRow);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTAgMjBWMGgyMHYyMEgwem0xLjkwNDgtNnY0aDE2LjE5MDR2LTRIMS45MDQ4em0wLTJoMTYuMTkwNFY4SDEuOTA0OHY0em0wLTZoMTYuMTkwNFYySDEuOTA0OHY0eiIgZmlsbD0iIzIzMkYzRSIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo=";